<template>
  <v-container fluid pr-4>
    <v-layout justify-center align-center my-4 ml-3 mr-2>
      <v-flex md12>
        <div class="headline text-light">
          {{campaign.name ? campaign.name : ''}}
        </div>
        <div class="f1-2em text-light pt-0" v-if="campaign.name">
          {{template ? template.name ? template.name : '' : ''}}
        </div>
      </v-flex>
    </v-layout>
    <v-layout justify-center align-center my-3 ml-3 mr-2>
      <v-flex md12 v-if="campaign.name">
        <funnel-graphic
          graphic-id="detailedCampaignGraphic"
          url="notification_schedules/channel_metrics"
          :filters="filtersGraphic"
          :labels="funnel[campaign.channel].labels"
          :search-on-create="true">
        </funnel-graphic>
      </v-flex>
    </v-layout>
    <data-table
      :filters="filters"
      :limit="6"
      :url="`/notification_schedules`"
      content="notificationScheduleLists"
      class="pr-2">
      <template slot="title">
        <v-layout justify-center align-center my-4>
          <v-flex md12>
            <div class="headline text-light">
              Detalles de gestión
            </div>
          </v-flex>
          <v-flex md2 pr-2>
            <v-btn
              block large
              @click="generateReport()">
                <v-icon small>fas fa-download</v-icon>
            </v-btn>
          </v-flex>
          <v-flex md3>
            <v-btn class="k-orange-linear white--text mb-0 mt-0" block large @click="$router.push(`/campaigns/${$route.params.campaign}/resend`)">
              REENVIAR CAMPAÑA
            </v-btn>
          </v-flex>
        </v-layout>
      </template>
      <template slot="navigation-bar">
        <v-flex lg9>
          <v-text-field
            v-model="filters.search"
            label="Buscar..."
            color="black"
            solo>
          </v-text-field>
        </v-flex>
        <v-flex lg3 pl-2>
          <v-select
            v-model="filters.status"
            :items="statuses"
            item-value="value"
            item-text="status"
            class="white--text"
            color="grey"
            solo>
            <template slot="selection" slot-scope="data">
              <div class="black--text">{{data.item.status}} ({{ data.item.total }})</div>
            </template>
            <template slot="item" slot-scope="data">
              <template v-if="typeof data.item !== 'object'">
                <v-list-tile-content v-text="data.item"></v-list-tile-content>
              </template>
              <template v-else>
                <v-list-tile-content>
                  <v-list-tile-title>{{data.item.status}} ({{data.item.total}})</v-list-tile-title>
                </v-list-tile-content>
              </template>
            </template>
          </v-select>
        </v-flex>
      </template>
    </data-table>
    <notification-schedule-detail></notification-schedule-detail>
  </v-container>
</template>

<script>
import Vue from 'vue';
import moment from 'moment';
import Chartist from 'chartist';
import EventBus from '@/event-bus';
import DataTable from '@/components/global/DataTable';
import notificationScheduleLists from '@/components/notification_schedule/NotificationScheduleList';
import notificationScheduleDetail from '@/components/notification_schedule/Detail';
import funnelGraphic from '@/components/panel/management/FunnelGraphic';
import permissionsMixin from '@/mixins/permissions';

window.Chartist = Chartist;

require('@/assets/js/ctBarLabels.js');

Vue.component('notificationScheduleLists', notificationScheduleLists);

export default {
  inject: ['$validator'],
  mixins: [
    permissionsMixin,
  ],
  components: {
    DataTable,
    funnelGraphic,
    notificationScheduleDetail,
  },
  data() {
    return {
      filtersGraphic: {
        campaign_id: this.$route.params.campaign,
        type: 'campaign',
        channel: 'human',
        fields: 'sent_at,read_at,click_at,payment_promise,payment_received',
        negative_statuses: 'Invalido,Marcado SPAM,Rebotado,Equivocado',
      },
      filters: {
        search: '',
        type: 2,
        status: '',
        sort: '-date',
        campaign_id: this.$route.params.campaign,
        ignore_programmed: 'false',
      },
      campaign: {},
      template: {
        name: '',
      },
      funnel: {
        email: {
          fields: 'sent_at,read_at,click_at,payment_promise,payment_received',
          labels: [
            'Total',
            'Enviados',
            'Leidos',
            'Click',
            'Compromisos de pago',
            'Pagados',
          ],
          negativeStatuses: 'Invalido,Marcado SPAM,Rebotado,Equivocado',
        },
        sms: {
          fields: 'sent_carrier_at,delivered_at,click_at',
          labels: [
            'Total',
            'Enviados',
            'Entregados',
            'Click',
          ],
          negativeStatuses: 'Invalido,No enviado,No entregado',
        },
        ivr: {
          fields: 'sent_carrier_at,delivered_at,read_at,payment_promise,payment_received',
          labels: [
            'Total',
            'Enviados',
            'Entregados',
            'Escuchados',
            'Compromisos de pago',
            'Pagados',
          ],
          negativeStatuses: 'Invalido,Ocupado,Equivocado,Error,No contesta,No enviado,Buzon de voz,Rechazado',
        },
        bot: {
          fields: 'sent_carrier_at,delivered_at,read_at,payment_promise,payment_received',
          labels: [
            'Total',
            'Enviados',
            'Entregados',
            'Escuchados',
            'Compromisos de pago',
            'Pagados',
          ],
          negativeStatuses: 'Invalido,No contesta,Rechazado,Ocupado,Error,Equivocado,Buzon de Voz,Sin compromiso',
        },
        human: {
          fields: 'sent_carrier_at,delivered_at,read_at,payment_promise,payment_received',
          labels: [
            'Total',
            'Enviados',
            'Entregados',
            'Escuchados',
            'Compromisos de pago',
            'Pagados',
          ],
          negativeStatuses: 'Invalido,No contesta,Rechazado,Ocupado,Error,Equivocado,Buzon de Voz,Sin compromiso',
        },
      },
      statuses: [],
      file: '',
      infoDialog: false,
      notificationDetail: {},
      stopMusic: false,
      notificationState: 1,
      dates: [],
    };
  },
  mounted() {
    EventBus.$on('showNotificationDetail', (id) => {
      this.axios.get(`notification_schedules/${id}`).then((response) => {
        this.dates = [];
        this.notificationDetail = response.data;
        if (response.data.processed_at !== null) {
          this.dates.push({
            processed_at: response.data.processed_at,
          });
        }
        if (response.data.sent_carrier_at !== null) {
          this.dates.push({
            sent_carrier_at: response.data.sent_carrier_at,
          });
        }
        if (response.data.sent_at !== null) {
          this.dates.push({
            sent_at: response.data.sent_at,
          });
        }
        if (response.data.delivered_at !== null) {
          this.dates.push({
            delivered_at: response.data.delivered_at,
          });
        }
        if (response.data.read_at !== null) {
          this.dates.push({
            read_at: response.data.read_at,
          });
        }
        if (response.data.click_at !== null) {
          this.dates.push({
            click_at: response.data.click_at,
          });
        }
        if (response.data.payment_promise !== null) {
          this.dates.push({
            payment_promise: response.data.payment_promise,
          });
        }
        this.infoDialog = true;
      }).catch(() => {
        EventBus.$emit('modal', 'Hubo un error al mostrar el detalle');
      });
    });
    EventBus.$on('rightDrawerSaved', () => {
      EventBus.$emit('update');
      this.infoDialog = false;
    });
    EventBus.$on('update', () => {
      this.getCampaign();
      this.updateStatus();
    });
    this.getCampaign();
    this.updateStatus();
  },
  destroyed() {
    EventBus.$off('notificationDetail');
    EventBus.$off('rightDrawerSaved');
    EventBus.$off('update');
  },
  methods: {
    generateReport() {
      this.$store.commit('SET_DOWNLOAD_CHANNEL', `company.${this.$auth.user().company.id}.${this.$auth.user().id}.download_report`);
      this.$store.dispatch('SEND_DOWNLOAD_REQUEST', {
        route: 'reports',
        params: {
          filters: {
            type: this.campaign.channel === 'human' ? 1 : 2,
            campaign: this.campaign.id,
            filename: `Gestiones de la campaña ${this.campaign.name}`,
          },
          functionName: 'managementTotal',
        },
      });
    },
    getCampaign() {
      /* eslint-disable */
      this.axios.get(`/campaigns/${this.$route.params.campaign}?fields=template_id,template_code,name,start_date,delivery_option,status,channel`).then((response) => {
        this.campaign = response.data;
        if (this.campaign.channel === 'human') {
          this.filters.type = '';
        }
        this.filtersGraphic.channel = response.data.channel;
        this.filtersGraphic.fields = this.funnel[response.data.channel].fields;
        this.filtersGraphic.negative_statuses = this.funnel[response.data.channel].negativeStatuses;
        EventBus.$emit('getDate', response.data.start_date);
        this.getTemplate(this.campaign.template_id, this.campaign.channel);
      }).catch(() => { });
    },
    getTemplate(template_id, channel) {
      if (channel !== 'bot' && channel !== 'ivr') {
        this.axios.get(`/templates/${template_id}?fields=name,template_id&paginate=0`).then((resp) => {
          this.template = resp.data;
        });
      } else if(channel === 'bot') {
        this.axios.get(`/bot_templates/${template_id}`).then((resp) => {
          this.template = resp.data;
        });
      } else {
        this.axios.get(`/ivr_templates/${template_id}`).then((resp) => {
          this.template = resp.data;
        });
      }
    },
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
    },
    rechargeData(id) {
      const formData = new FormData();
      formData.append('file', this.file);
      this.axios.post(`/campaigns/${id}/recharge`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).then(() => {
        this.dialogRecharge = false;
        EventBus.$emit('update');
      }).catch((e) => {
        EventBus.$emit('modal', e.response.data);
      });
    },
    updateStatus() {
      this.axios.get(`/notification_schedules/live_status?campaign=${this.$route.params.campaign}&type=${this.campaign.channel === 'human' ? '1' : '2'}`).then((response) => {
        this.statuses = response.data;
        const totalEstados = this.sum('total', this.statuses);
        this.statuses.unshift({
          status: 'Estados',
          value: '',
          total: totalEstados,
        });
      });
    },
    sum(prop, array) {
      let total = 0;
      for (let i = 0; i < array.length; i += 1) {
        total += array[i][prop];
      }
      return total;
    },
    formatDate(date, firstFormat, dateFormat) {
      return moment(date, firstFormat).format(dateFormat);
    },
    openRightDrawer() {
      EventBus.$emit('openRightDrawer');
    },
    changeStatus(id) {
      this.axios.patch(`/notification_schedules/${id}`, {
        status: 'Programado',
      }).then(() => {
        EventBus.$emit('closeRightDrawer');
        EventBus.$emit('rightDrawerSaved');
        this.dialog = false;
      }).catch(() => { });
    },
    check(){
      return this.checkPermissions([
        'create_campaigns',
      ]);
    },
  },
  computed: {
    formattedDate() {
      return moment(this.notificationDetail.schedule_date, 'YYYY-MM-DD').format('DD/MM/YYYY');
    },
    timeDate() {
      return moment(this.notificationDetail.schedule_date, 'YYYY-MM-DD HH:mm').format('h:mm A');
    },
    dialogTitle() {
      return `${this.form.status === 'Detenido' ? 'Parar' : 'Reanudar'} notificaciones`;
    },
  },
  watch: {
    filters: {
      handler(val) {
        this.updateStatus();
      },
      deep: true,
    },
    infoDialog(val) {
      if (!val) {
        this.notificationDetail = {};
      }
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/campaign/CampaignDetail.vue